<template>
  <section id="calendar_container">
    <div class="columns">
      <div class="column">
        <CompanySelector v-model="company" />
      </div>
      <div class="column">
        <b-field label="Clasificación">
          <b-select
            placeholder="Seleccione una Clasificación"
            expanded
            v-model="clasification"
            v-validate="'required'"
            name="classification"
          >
            <option
              v-for="option in clasifications"
              :value="option.id"
              :key="option.id"
              :id="option.id"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <span class="show-error">{{ errors.first("classification") }}</span>
      </div>
      <div class="column">
        <b-field label=" Fecha">
          <b-datepicker
            v-validate="'required'"
            v-model="selectedDate"
            placeholder="Seleccione una fecha..."
            icon="calendar-today"
            name="date"
          >
          </b-datepicker>
        </b-field>
        <span class="show-error">{{ errors.first("date") }}</span>
      </div>
      <div class="column mt-checkbox">
        <b-checkbox v-model="applyAll" true-value="Y" false-value="N">
          Aplicar a todos los parqueaderos
        </b-checkbox>
      </div>
    </div>
    <div class="buttons button-group">
      <b-button @click="createCalendar()" type="is-info"> Agregar</b-button>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData" :selected.sync="selected" focusable>
          <b-table-column field="company" label="Empresa" v-slot="props">
            {{ props.row.company.name }}
          </b-table-column>

          <b-table-column field="date" label="Fecha" v-slot="props">
            {{ props.row.day }}
          </b-table-column>
          <b-table-column field="type" label="Tipo" v-slot="props">
            {{ getDayType(props.row.classification) }}
          </b-table-column>
          <template #bottom-left></template>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="buttons button-group">
      <b-button
        v-if="selected != null"
        @click="openDeleteModal()"
        type="is-info"
      >
        Eliminar
      </b-button>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import { ROUTES } from "../../global/api_routes";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { confirmation } from "../../global/utils";
import { configToast, TOAST_TYPES } from "../../global/toast";
import CompanySelector from "../../components/Shared/CompanySelector";

export default {
  name: "CreateCompany",
  watch: {
    company() {
      if (this.company) {
        this.getCalendar();
        return;
      }
      this.company = null;
    },
    selectedDate() {
      const dateSend = moment(this.selectedDate).format("YYYY-MM-DD");
      this.dateSend = dateSend;
    },
  },
  components: { Treeselect, CompanySelector },
  data: () => ({
    company: null,
    clasification: null,
    selected: null,
    selectedDate: null,
    dateSend: null,
    applyAll: null,
    tableData: [],
    isLoading: false,
    tableLoading: false,
    clasifications: [
      { name: "Festivo", id: "H" },
      { name: "Especial", id: "S" },
    ],
  }),
  mounted() {},
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#calendar_container");
      return instance.open(message, type);
    },
    getDayType(classification) {
      switch (classification) {
        case "H":
          return "Festivo";
        case "S":
          return "Especial";
      }
    },
    openDeleteModal() {
      const classification = this.getDayType(this.selected.classification);
      confirmation(this, `¿Desea eliminar el día ${classification}?`).then(
        (result) => {
          if (!result) {
            return;
          }
          this.deleteCalendar();
        }
      );
    },
    deleteCalendar() {
      this.$http
        .delete(ROUTES.DASHBOARD.CALENDAR.DELETE_CALENDAR, {
          params: {
            calendarId: this.selected.code,
          },
        })
        .then(({ data }) => {
          if (data.code <= 0) {
            this.toast(data.message, TOAST_TYPES.ERROR);
            return;
          }
          this.selected = null;
          this.getCalendar();
          this.toast(data.message, TOAST_TYPES.SUCCESS);
        });
    },
    getCalendar() {
      const company = this.company;
      this.$http
        .get(ROUTES.DASHBOARD.CALENDAR.GET_CALENDAR, {
          params: { companyId: company },
        })
        .then(({ data }) => {
          if (data.code <= 0) {
            this.toast(data.message, TOAST_TYPES.ERROR);
            this.tableData = [];
            return;
          }
          this.tableData = data.info;
          this.toast(data.message, TOAST_TYPES.SUCCESS);
        });
    },
    createCalendar() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        const { company, clasification, dateSend } = this;
        const send = {
          day: dateSend,
          classification: clasification,
          company: {
            code: company,
          },
        };
        this.$http
          .post(ROUTES.DASHBOARD.CALENDAR.SAVE_CALENDAR, send)
          .then(({ data }) => {
            if (data.code <= 0) {
              this.toast(data.message, TOAST_TYPES.ERROR);
              return;
            }
            this.toast(data.message, TOAST_TYPES.SUCCESS);
            this.getCalendar();
          });
      });
    },
  },
};
</script>
<style type="scss">
.btn-save {
  display: flex;
  margin: 0 auto;
  width: 30%;
  justify-content: center;
}

.label {
  font-size: 1em;
}

.header-modal {
  background-color: #2962ff;
}

.modal-button-custom {
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-top: 25px;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5em;
}

.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0.1rem !important;
}

.notices {
  z-index: 1000000000000000000 !important;
}
</style>
